import React from 'react'

import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import containerStyles from '../styles/containerStyles';
import authStyles from '../../pages/user/authStyles';

const BoxWithLogo = ({ children, title, logo, altTitle }) => {
    const classes = containerStyles();
    const authClasses = authStyles();

    return (
        <Container className={classes.boxContainer}>
            <br />
            <Paper className={classes.paper}>
                <img
                    src={logo}
                    className={classes.logo}
                    alt={altTitle ? altTitle : "DIGTL Dashboard"}
                />
            </Paper>
            <Paper className={classes.paper}>
                <Container maxWidth="xs">
                    <Typography
                        component="h2"
                        className={authClasses.title}
                    >
                        {title}
                    </Typography>

                    {/* Content */}
                    {children}
                </Container>
            </Paper>
        </Container>
    )
}

export default BoxWithLogo
